import { CombinationsOptions, GlobalOptions } from '@/enums/global/GlobalOptions';
import { alternativeAllowedCombinationsGuideProductsForAlternativePIds } from '@/regex/allowedEntitiesForCombinationsGuide';
import i18n from '@/i18n';

export const combinationsConfiguratorSteps = [
    {
        name: 'Selection',
        description: i18n.t(
            'As the first step in configuring the units, select the positions that will make up the cabinet. With the configurator, you can choose 2 or 3 positions for the unit. If you need more positions, please contact us.'
        ),
    },
    {
        name: 'Sequence',
        description: i18n.t('Choose the order of positions (from left to right).'),
    },
    {
        name: 'Size',
        description: i18n.t(
            'Select the total width of the combined cabinet. The total width must be equal to or at most equal to the sum of the widths of both positions.'
        ),
    },
    {
        name: 'Configuration',
        description: i18n.t(
            'Select the drive side and the guides between the assemblies. Be sure that the option to select a partition guide is only available when the heights of the positions are the same. If the heights are different, you only have the option to select single guides. Based on your selections, the code for the combined cabinet will be generated automatically.'
        ),
    },
];

export const getRequiredCombinationsChecklistFields = (productName: string) => {
    const isAlternativeProduct = alternativeAllowedCombinationsGuideProductsForAlternativePIds.includes(productName);

    const leftGuidePID = isAlternativeProduct ? GlobalOptions.ALTERNATIVE_LEFT_GUIDE_PID : GlobalOptions.LEFT_GUIDE_PID;
    const rightGuidePID = isAlternativeProduct
        ? GlobalOptions.ALTERNATIVE_RIGHT_GUIDE_PID
        : GlobalOptions.RIGHT_GUIDE_PID;

    return [
        {
            pid: 'productId',
            label: 'Num.',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.SISTEM_PID,
            label: 'System',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.QUANTITY_PID,
            label: 'Quantity',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.WIDTH_PID,
            label: 'Width',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.HEIGHT_PID,
            label: 'Height',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.POSITION_PID,
            label: 'Position',
            type: 'input',
            active: true,
            shouldUpdateConfigurator: false,
            isReadOnly: true,
            segment: 'table',
        },
        {
            pid: CombinationsOptions.ASSEMBLY_POSITION_PID,
            label: 'Assembly Position',
            type: 'dropdown',
            active: true,
            shouldUpdateConfigurator: true,
            isReadOnly: false,
            segment: 'table',
            options: [
                { label: '1', value: '1' },
                { label: '2', value: '2' },
                { label: '3', value: '3' },
            ],
            step: 2,
        },
        {
            pid: CombinationsOptions.DRIVE_PID,
            label: 'Drive',
            type: 'dropdown',
            active: true,
            shouldUpdateConfigurator: true,
            isReadOnly: false,
            segment: 'configurator',
        },
        {
            pid: leftGuidePID,
            label: 'Left Guide',
            type: 'dropdown',
            active: false,
            shouldUpdateConfigurator: true,
            isReadOnly: true,
            segment: 'configurator',
        },
        {
            pid: rightGuidePID,
            label: 'Right Guide',
            type: 'dropdown',
            active: false,
            shouldUpdateConfigurator: true,
            isReadOnly: true,
            segment: 'configurator',
        },
        {
            pid: CombinationsOptions.TOTAL_WIDTH_PID,
            label: 'Total Width',
            type: 'input',
            active: false,
            shouldUpdateConfigurator: true,
            isReadOnly: false,
            segment: 'totalWidth',
        },
        {
            pid: CombinationsOptions.COMBINATION_TYPE_PID,
            label: 'Combination type',
            type: 'input',
            active: false,
            shouldUpdateConfigurator: true,
            isReadOnly: true,
            segment: 'configurator',
        },
        {
            pid: CombinationsOptions.NUMBER_OF_COMBINATIONS_PID,
            label: 'Number of combinations',
            type: 'input',
            active: false,
            shouldUpdateConfigurator: true,
            isReadOnly: true,
            segment: '',
        },
    ];
};
